var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBird5 = function SvgBird5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "37.5 75 262.5 210"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.5 270 8.621-12.932 49.708 8.981 1.333-7.38-46.507-8.403L112.5 225l97.5-12.717V285h7.5v-73.696l22.5-2.935V285h7.5v-77.609L285 202.5 247.5 120 300 75h-82.5v45L75 187.5l5.456 60.02-41.62-7.52-1.334 7.38 43.659 7.888zm15-67.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0"
  })));
};
export default SvgBird5;